import store from '@/store'
import network from '@/utils/network'
import { agencyPath } from '@/utils/api'
import { $ui } from '@/utils/ui'
import { MODAL_EVENT_UPDATE_MANAGER } from '@/consts/app'

/**
 * Créé / met à jour un manager
 * @returns {Promise<>}
 */
export const postAgencyManager = async (manager) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/manager`, manager)
  return r.data
}

/**
 * Supprime un manager
 * @returns {Promise<>}
 */
export const deleteAgencyManager = async (manager) => {
  const r = await network.delete(`${agencyPath()}/manager/${manager.id}`)
  $ui.$emit(MODAL_EVENT_UPDATE_MANAGER, [{ ...manager, _deleted: true }])
  return r.data
}
